<div class="page-head-section">
  <p>Audited Financial Statement</p>
</div>

<div class="rules-content">
  <!-- <p class="subhead">Title</p> -->

  <div
    *ngFor="let data of AnnualData; let i = index"
    class="rules-row"
    (click)="toLink(data.link)"
  >
   {{data?.name}}
  </div>
</div>
